// Critical CSS utility for above-the-fold content
export const criticalCss = `
/* Critical CSS for above-the-fold content */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Inter, sans-serif;
  line-height: 1.6;
  color: hsl(222.2, 84%, 4.9%);
  background-color: hsl(210, 40%, 98%);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100vh;
}

/* Critical layout styles for header/hero */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: hsl(210, 40%, 98%);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid hsl(214.3, 31.8%, 91.4%);
}

.hero {
  padding-top: 6rem;
  padding-bottom: 4rem;
  text-align: center;
}

.hero h1 {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1rem;
  font-family: Poppins, sans-serif;
}

/* Hide non-critical content initially */
.below-fold {
  opacity: 0;
  transform: translateY(20px);
}

/* Loading state */
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
`;

export const injectCriticalCss = () => {
  if (typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = criticalCss;
    style.setAttribute('data-critical-css', 'true');
    document.head.appendChild(style);
  }
};